const NOMBRES_TRANSPORTE = { 
  MARITIMO: "MARÍTIMO",
  TERRESTRE: "TERRESTRE",
  AEREO: "AEREO",
};

export default NOMBRES_TRANSPORTE;